var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 19C10.9332 19 10.4737 18.5178 10.4737 17.9231L10.4737 11.8974L6.02634 11.8974C5.61124 11.8974 5.23701 11.6351 5.07815 11.2326C4.9193 10.8302 5.00711 10.367 5.30063 10.059L10.7743 4.31542C10.8766 4.20806 10.9952 4.1281 11.1216 4.07555C11.2387 4.0268 11.3664 4 11.5 4C11.6447 4 11.7824 4.03142 11.9073 4.08811C12.0057 4.13273 12.0989 4.19429 12.1827 4.2728C12.1991 4.28809 12.2149 4.30392 12.2303 4.32027L17.6994 10.059C17.9929 10.367 18.0807 10.8302 17.9218 11.2326C17.763 11.6351 17.3888 11.8974 16.9737 11.8974L12.5263 11.8974L12.5263 17.9231C12.5263 18.5178 12.0668 19 11.5 19Z",
    fill: "#2c8ec6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.b75eeaa2c707def39fc6af9be825b07b.svg";
export { ForwardRef as ReactComponent };